<ng-template #template>
  <div *ngIf="data?.items.length > 1">
    <!--<nav class="navbar navbar-expand-lg navbar-light px-lg-0 py-0 sub-menu"> -->
    <div
      class="navbar-collapse w-100 navbar navbar-expand-lg navbar-light px-lg-0 py-0 sub-menu"
    >
      <ul
        class="nav navbar-nav ml-auto w-100 font-small"
        aria-role="tablist"
        aria-label="navigation tabs"
      >
        <div
          *ngFor="let itm of data?.items; let idx = index"
          [class.active]="itm.value.startsWith(getSelectedPath())"
        >
          <a
            class="nav-link text-uppercase"
            [attr.aria-label]="itm.caption"
            [routerLink]="['/' + getPage() + '/' + itm.value]"
            queryParamsHandling="merge"
            style="cursor: pointer"
            role="tab"
            [attr.aria-selected]="itm.value.startsWith(getSelectedPath())"
            *ngIf="itm.value !== 'financial'"
            >{{ itm.caption }}</a
          >
          <a
            class="nav-link text-uppercase"
            [attr.aria-label]="itm.caption"
            [routerLink]="['/' + getPage() + '/' + itm.value]"
            [queryParams]="getFinancialQueryParams()"
            style="cursor: pointer"
            role="tab"
            [attr.aria-selected]="itm.value.startsWith(getSelectedPath())"
            *ngIf="itm.value === 'financial'"
            >{{ itm.caption }}</a
          >
        </div>
      </ul>
    </div>
    <!--</nav>-->
    <hr *ngIf="hasSubMenuItems() && !isWhiteLine" />
    <hr class="hr-white" *ngIf="hasSubMenuItems() && isWhiteLine" />
  </div>
  <div
    id="sticky-row"
    *ngIf="hasSubMenuItems()"
    [class.sticky]="sticky"
    #stickyMenu
  >
    <div>
      <div class="row px-0">
        <ul
          class="col sub-type"
          aria-role="tablist"
          aria-label="navigation second level tabs"
        >
          <a
            *ngFor="let itm of getSubMenuItems()"
            class="btn btn-outline-secondary font-btn-small text-uppercase"
            role="tab"
            [attr.aria-selected]="itm.value === getSelectedSubPath()"
            [class.btn-primary]="itm.value === getSelectedSubPath()"
            [class.btn-outline-secondary]="itm.value !== getSelectedSubPath()"
            [ngClass]="[itm.value === getSelectedSubPath() ? cssColor : '']"
            [routerLink]="['/' + getPage(), getSelectedPath(), itm.value]"
            queryParamsHandling="merge"
            >{{ itm.caption }}</a
          >
        </ul>
      </div>
    </div>
  </div>
</ng-template>
